import React from "react";
import {
  CardText,
  FlatButton,
  AutoComplete,
  TextField,
  Dialog
} from "material-ui";
import { commitMutation, graphql } from "react-relay";
import PropTypes from "prop-types";
import moment from "moment";

import environment from "../../relay/environment";
import DateRange from "../DateRangeComponent";
import search from "../../rest";

export default class AddSegment extends React.Component {
  static propTypes = {
    trip: PropTypes.shape().isRequired,
    onComplete: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    const {
      trip: { specificDates, startDate: tripStartDate, segments }
    } = props;

    let startDate = "";
    const filteredSegments = segments.filter(
      segment => !segment.cancelled && segment.endDate
    );
    if (filteredSegments.length > 0) {
      startDate = filteredSegments.map(segment => segment.endDate).slice(-1)[0];
    } else if (specificDates) {
      startDate = tripStartDate;
    }

    this.state = {
      segmentAutocompleteData: [],
      id: "",
      name: "",
      startDate,
      endDate: "",
      notes: "",
      confirmNewVendor: false
    };
  }

  cancel = () => {
    this.props.onComplete();
  };

  handleUpdateSegmentAutocomplete = value => {
    search("auto/vendor", value)
      .then(response => {
        const { objects } = response;
        this.setState({
          name: value,
          segmentAutocompleteData: objects.map(object => ({
            text: object.name,
            value: object.relayId,
            name: object.name,
            score: object.score
          }))
        });
      })
      .catch(response => {
        console.log(response);
      });
  };

  vendorSelected = (selected, index) => {
    if (index !== -1) {
      const { value: id, name } = selected;
      this.setState({ id, name });
    }
  };

  selectAlternateVendor = (id, name) => () => {
    this.setState({ id, name, confirmNewVendor: false }, () =>
      this.addVendor()
    );
  };

  updateDates = e => {
    const { startDate, endDate } = e;
    this.setState({ startDate, endDate });
  };

  save = () => {
    if (!this.state.id) {
      this.setState({ confirmNewVendor: true });
    } else {
      this.addVendor();
    }
  };

  cancelNewVendor = () => {
    this.setState({ confirmNewVendor: false });
  };

  confirmNewVendor = () => {
    this.setState({ confirmNewVendor: false });
    this.addVendor();
  };

  addVendor = () => {
    const {
      trip: { id: tripId },
      onComplete
    } = this.props;
    const { id: vendorId, name: vendorName, notes } = this.state;
    let { startDate, endDate } = this.state;

    if (moment.isMoment(startDate)) {
      startDate = startDate.format("YYYY-MM-DDTHH:mm:ssZZ");
    }
    if (moment.isMoment(endDate)) {
      endDate = endDate.format("YYYY-MM-DDTHH:mm:ssZZ");
    }

    commitMutation(environment, {
      mutation: graphql`
        mutation AddSegment_AddSegmentToTrip_Mutation(
          $input: AddSegmentInput!
        ) {
          addSegment(input: $input) {
            trip {
              numSegments
              dropbox
              invoice
              draftVip
              book
              cancel
              welcomeHome
              tasks {
                taskType
                description
                completed
                voided
                history {
                  name
                  action
                  timestamp
                }
              }
              segments {
                id
                vendor {
                  id
                  name
                  amenityPrograms
                }
                trip {
                  id
                  searchId
                }
                name
                dateString
                startDate
                endDate
                category
                bedType
                amenityProgram
                numAdults
                numChildren
                smokingRoom
                rates
                currency
                averageDailyRate
                cancellationDeadline
                dropbox
                invoiced
                vipDrafted
                vipSent
                booked
                cancelled
                sabreLocator
                confirmationNumber
                cancellationNumber
                vipLetter
                notes {
                  id
                  owner {
                    id
                    firstName
                  }
                  content
                  created
                }
              }
            }
          }
        }
      `,
      variables: {
        input: {
          tripId,
          vendorId,
          vendorName,
          startDate,
          endDate,
          notes
        }
      },
      onCompleted: () => onComplete(),
      onError: err => alert(err)
    });
  };

  updateNotes = e => {
    const {
      target: { value }
    } = e;
    this.setState({ notes: value });
  };

  render() {
    const {
      segmentAutocompleteData,
      name,
      startDate,
      endDate,
      confirmNewVendor,
      notes
    } = this.state;
    const {
      trip: { travelStartDate, travelEndDate, specificDates, timeframe }
    } = this.props;
    const ready =
      name !== "" &&
      ((startDate && endDate) ||
        (specificDates === true && travelStartDate && travelEndDate) ||
        (specificDates === false && timeframe));

    const actions = [
      <FlatButton label="No" primary onTouchTap={this.cancelNewVendor} />,
      <FlatButton label="Yes" primary onTouchTap={this.confirmNewVendor} />
    ];

    return (
      <div>
        <CardText>
          <div style={styles.formFieldsStyle}>
            <AutoComplete
              style={styles.formFieldStyle}
              menuStyle={{ width: 500 }}
              listStyle={{ width: 500 }}
              floatingLabelText="Name"
              dataSource={segmentAutocompleteData}
              onUpdateInput={this.handleUpdateSegmentAutocomplete}
              onNewRequest={this.vendorSelected}
              filter={() => true}
            />
            <DateRange
              startValue={startDate}
              endValue={endDate}
              startLabel="Start Date"
              endLabel="End Date"
              onChange={this.updateDates}
            />
          </div>
          <TextField
            floatingLabelText="Notes"
            value={notes}
            onChange={this.updateNotes}
            multiLine
            fullWidth
          />
          <div style={styles.formActionsStyle}>
            <FlatButton label="Cancel" secondary onTouchTap={this.cancel} />
            <FlatButton
              label="Confirm"
              primary
              onTouchTap={this.save}
              disabled={!ready}
            />
          </div>
        </CardText>
        <Dialog
          title="Confirm New Vendor"
          actions={actions}
          modal
          open={confirmNewVendor}
        >
          <p>
            You did not select an existing vendor from our database. Are you
            sure that &quot;{name}&quot; is not one of the following?
          </p>
          <ul style={styles.alternativeList}>
            {segmentAutocompleteData
              .filter(({ score }) => score > 1)
              .slice(0, 10)
              .map(({ name: vendorName, value: id }) => (
                <li key={id} style={styles.alternativeVendor}>
                  <span>{vendorName}</span>
                  <FlatButton
                    label="select"
                    onTouchTap={this.selectAlternateVendor(id, name)}
                  />
                </li>
              ))}
          </ul>
        </Dialog>
      </div>
    );
  }
}

const styles = {
  formFieldsStyle: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "flex-end"
  },
  formFieldStyle: {
    width: 256,
    marginRight: 24
  },
  formActionsStyle: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end"
  },
  alternativeList: {
    display: "flex",
    flexDirection: "column",
    width: "50%"
  },
  alternativeVendor: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    alignItems: "baseline"
  }
};



// WEBPACK FOOTER //
// /src/components/Trips/AddSegment.js